// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ReactToRactiveAdapter } from '../ReactToRactiveAdapter';
import { NotificationMessage } from '../ReactControls/elements/NotificationMessage';
export class NotificationMessageRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
}
ReactToRactiveAdapter.extendWith(NotificationMessageRactive, {
    template: '<div class="notification-message-wrapper"></div>',
    mountContainer: '.notification-message-wrapper',
    reactComponent: NotificationMessage,
    data: function () {
        const props = {
            type: 'none',
            text: ''
        };
        return { props };
    }
});
